/**
 * Represents a group of items within a `toolbar` element.
 */
export class ToolbarGroupCustomElement
{
}
